import { SVGProps, Ref, forwardRef } from 'react';

export const UturnRightOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="m16 1 7 7-7 7-1.273-1.273L19.554 8.9H8.95a6.15 6.15 0 0 0 0 12.3H21V23H8.95a7.95 7.95 0 1 1 0-15.9h10.604l-4.827-4.827z"
                fill="currentColor"
            />
        </g>
    </svg>
));
UturnRightOutlinedSize24Glyph.displayName = 'UturnRightOutlinedSize24Glyph';
